module.exports = __webpack_public_path__ + "static/usprawnianie procesu sprzedazy-1938dd0acc5e800995b72e863df3ae67.jpg";